import axios from 'axios';

import { getAccessToken } from './token';

export const client = axios.create({
  baseURL: process.env.REACT_APP_PROXY_BASE_URL,
});

client.interceptors.request.use(async config => {
  const token = await getAccessToken();
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});
